import React from "react";
import { Field, getIn } from "formik";
import { Select } from "../../native";
export default ({ children, onSelect, ...props }) => (
  <Field
    name={props.name}
    render={({ field, form: { touched, errors } }) => {
      const error = errors[field.name] || getIn(errors, field.name);
      const isDirty = touched[field.name] || getIn(touched, field.name);
      return (
        <Select
          error={isDirty && error}
          {...field}
          {...props}
          onChange={(...args) => {
            onSelect && onSelect(...args);
            return field.onChange(...args);
          }}
        >
          {children}
        </Select>
      );
    }}
  />
);



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/Select/index.js